/* minaki-a11y.js - accessibility fixes for markup the vendor theme builds in JavaScript
   (Lighthouse a11y audit 2026-10-05). Static markup is fixed in the Liquid itself; this only covers
   elements that don't exist until the theme's own scripts render them. Safe to run repeatedly. */
(function () {
  'use strict';

  function cardTitle(el) {
    var card = el.closest('.t4s-product');
    var t = card && card.querySelector('.t4s-product-title');
    return t ? t.textContent.trim() : '';
  }

  function hasName(el) {
    // visible text only: these buttons carry their label in a display:none span, which doesn't count
    return (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby') || (el.innerText || '').trim() || el.getAttribute('title'));
  }

  function labelIconControls(root) {
    root.querySelectorAll('a.t4s-pr-item-btn, button.t4s-pr-item-btn, .t4s-product-btns2 a, .t4s-product-btns2 button').forEach(function (el) {
      if (hasName(el)) return;
      var title = cardTitle(el);
      var cls = (el.className || '') + ' ' + (el.parentElement ? el.parentElement.className : '');
      var verb = /wis/.test(cls) || el.hasAttribute('data-action-wishlist') ? 'Add to wishlist' :
                 /quickview|qv/.test(cls) || el.hasAttribute('data-action-quickview') ? 'Quick view' :
                 /compare/.test(cls) ? 'Compare' : 'View';
      el.setAttribute('aria-label', title ? verb + ': ' + title : verb);
    });
    // slideshow cover links: name them after the slide's heading
    root.querySelectorAll('.t4s-slideshow-item a.t4s-full-width-link').forEach(function (a) {
      if (hasName(a)) return;
      var slide = a.closest('.t4s-slideshow-item');
      var h = slide && slide.querySelector('h1, h2, h3, .t4s-slideshow-heading, [class*="heading"]');
      var text = h ? h.textContent.replace(/\s+/g, ' ').trim() : '';
      a.setAttribute('aria-label', text || 'View collection');
    });
  }

  // Off-screen slider cells are aria-hidden; their links must not be keyboard-focusable.
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';
  function syncHiddenFocus(cell) {
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    cell.querySelectorAll(FOCUSABLE).forEach(function (el) {
      if (hidden) {
        if (!el.hasAttribute('data-minaki-tabindex')) el.setAttribute('data-minaki-tabindex', el.getAttribute('tabindex') || '');
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute('data-minaki-tabindex')) {
        var prev = el.getAttribute('data-minaki-tabindex');
        if (prev) el.setAttribute('tabindex', prev); else el.removeAttribute('tabindex');
        el.removeAttribute('data-minaki-tabindex');
      }
    });
  }

  // Flickity wraps <li> tabs in its own <div>s, which breaks ul > li semantics: expose them as tabs instead.
  function fixTabRails(root) {
    root.querySelectorAll('ul[data-t4s-tab-ul2], ul.t4s-tabs-ul').forEach(function (ul) {
      if (!ul.querySelector('.flickityt4s-viewport')) return;
      ul.setAttribute('role', 'tablist');
      ul.querySelectorAll('li').forEach(function (li) {
        li.setAttribute('role', 'presentation');
        var a = li.querySelector('a, button');
        if (a) { a.setAttribute('role', 'tab'); a.setAttribute('aria-selected', li.classList.contains('is--active') || li.classList.contains('t4s-tab-active') ? 'true' : 'false'); }
      });
    });
  }

  function run(root) {
    labelIconControls(root);
    fixTabRails(root);
    root.querySelectorAll('[aria-hidden="true"]').forEach(function (c) { if (c.querySelector(FOCUSABLE)) syncHiddenFocus(c); });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestIdleCallback || setTimeout)(function () { queued = false; run(document); }, { timeout: 500 });
  }

  function start() {
    run(document);
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'attributes' && r.attributeName === 'aria-hidden') syncHiddenFocus(r.target);
        else if (r.type === 'childList' && r.addedNodes.length) schedule();
      }
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
